import { Link } from 'react-router-dom';

const tenjinGenres = [
  '貴金属', '宝石', 'ブランド品', 'カメラ', 'お酒',
  '金券', '骨董品', '家電', '楽器', '電動工具',
  'ゲーム', 'スマホ・タブレット',
];

const mangakuGenres = [
  'ポケモンカード', 'ワンピースカード', 'ユニオンアリーナ',
  'デュエルマスターズ', 'ヴァイスシュバルツ',
];

export default function OurServices() {
  return (
    <section id="services" className="py-24 bg-primary-pale">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-16">
          <span className="text-xs tracking-[0.3em] text-primary font-medium uppercase mb-3">Our Services</span>
          <h2 className="text-4xl md:text-5xl font-serif text-primary mb-4">事業内容</h2>
          <div className="w-16 h-0.5 bg-primary/30 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Card 1: 天神屋 */}
          <div className="bg-white rounded-2xl overflow-hidden group hover:shadow-md transition-shadow duration-300">
            <div className="relative h-64 overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/ce8a7af2297c6543a3fb717b20c526dd.jpg"
                alt="天神屋"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-6">
                <span className="bg-primary text-white text-xs px-3 py-1 rounded-full font-medium">出張買取専門</span>
              </div>
            </div>
            <div className="p-8">
              <div className="flex items-start justify-between mb-2">
                <div>
                  <h3 className="text-2xl font-serif font-semibold text-primary">天神屋</h3>
                  <p className="text-sm text-gray-400 mt-1">買取専門店</p>
                </div>
                <div className="w-10 h-10 flex items-center justify-center bg-primary-pale rounded-full">
                  <i className="ri-store-2-line text-primary"></i>
                </div>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed mt-4 mb-6">
                ご自宅や職場へ出張し、専門スタッフが丁寧に査定いたします。
                貴金属からブランド品まで、幅広いジャンルを高価買取。
                査定・出張費用は一切無料です。
              </p>
              <div>
                <p className="text-xs font-semibold text-primary/60 tracking-wider uppercase mb-3">取扱ジャンル</p>
                <div className="flex flex-wrap gap-2">
                  {tenjinGenres.map((genre) => (
                    <span
                      key={genre}
                      className="bg-primary-pale text-primary text-xs px-3 py-1 rounded-full font-medium"
                    >
                      {genre}
                    </span>
                  ))}
                </div>
              </div>
              <div className="mt-6 pt-6 border-t border-gray-100 flex items-center justify-between gap-3">
                <div className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-primary text-sm"></i>
                  </div>
                  <p className="text-xs text-gray-500">本社所在地（出張買取専門）</p>
                </div>
                <Link
                  to="/tenjin-ya"
                  className="inline-flex items-center gap-1.5 bg-primary text-white text-xs px-4 py-2 rounded-full font-medium whitespace-nowrap hover:bg-primary-light transition-colors cursor-pointer"
                >
                  詳細を見る
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </Link>
              </div>
            </div>
          </div>

          {/* Card 2: まんがく */}
          <div className="bg-white rounded-2xl overflow-hidden group hover:shadow-md transition-shadow duration-300">
            <div className="relative h-64 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=colorful%20bright%20modern%20japanese%20trading%20card%20game%20shop%20pokemon%20one%20piece%20cards%20neatly%20displayed%20glass%20showcase%20illuminated%20display%20cases%20vibrant%20colors%20organized%20clean%20card%20collector%20retail%20store%20interior&width=800&height=500&seq=botan-mangaku&orientation=landscape"
                alt="まんがく"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-6">
                <span className="bg-accent text-white text-xs px-3 py-1 rounded-full font-medium">カード専門店</span>
              </div>
            </div>
            <div className="p-8">
              <div className="flex items-start justify-between mb-2">
                <div>
                  <h3 className="text-2xl font-serif font-semibold text-primary">まんがく</h3>
                  <p className="text-sm text-gray-400 mt-1">カードショップ</p>
                </div>
                <div className="w-10 h-10 flex items-center justify-center bg-primary-pale rounded-full">
                  <i className="ri-gamepad-line text-primary"></i>
                </div>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed mt-4 mb-6">
                香川県高松市に構えるトレーディングカード専門店。
                ポケモンカードをはじめとした人気TCGを幅広く取り扱っています。
                買取・販売ともに対応しております。
              </p>
              <div>
                <p className="text-xs font-semibold text-primary/60 tracking-wider uppercase mb-3">取扱ジャンル</p>
                <div className="flex flex-wrap gap-2">
                  {mangakuGenres.map((genre) => (
                    <span
                      key={genre}
                      className="bg-primary-pale text-primary text-xs px-3 py-1 rounded-full font-medium"
                    >
                      {genre}
                    </span>
                  ))}
                </div>
              </div>
              <div className="mt-6 pt-6 border-t border-gray-100 flex items-center justify-between gap-3">
                <div className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-primary text-sm"></i>
                  </div>
                  <p className="text-xs text-gray-500">香川県高松市瓦町2-1-28 高尾ビル2F南</p>
                </div>
                <Link
                  to="/mangaku"
                  className="inline-flex items-center gap-1.5 bg-accent text-white text-xs px-4 py-2 rounded-full font-medium whitespace-nowrap hover:opacity-90 transition-opacity cursor-pointer"
                >
                  詳細を見る
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
